import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useContext } from "react";
import LoadingBox from "../../components/common/LoadingBox";
import { AccountContext } from "../../context/AccountContextComponent";
import useAccountId, {
  useBreadcrumbsWithCustomDomain,
} from "../../hooks/customDomainHooks";
import useTabNavigation from "../../hooks/useTabNavigation";
import PageShell from "../../layout/PageShell";
import CurrentBilling from "../Billing/CurrentBilling";
import SubscriptionSettings from "../Billing/SubscriptionSettings";
import IntegrationsTab from "./Integrations/IntegrationsTab";
import Modules from "./Modules/Modules";
import ViewAccount from "./ViewAccount";

const AccountPage = () => {
  const { accountId } = useAccountId();
  const {
    currentProfile,
    accountData,
    isLoading,
    errorAccountData,
    isErrorAccountData,
  } = useContext(AccountContext);

  const breadcrumbs = useBreadcrumbsWithCustomDomain([
    { type: "HOME", href: `/${accountId}/home` },
    { name: "Company Settings" },
  ]);

  const profileRole = currentProfile?.role;

  const allTabs = [
    {
      name: "Company",
      rolesAllowed: ["EMPLOYEE", "ADMIN", "OWNER", "PARTNER"],
      content: <ViewAccount account={accountData} />,
    },
    {
      name: "Integrations",
      rolesAllowed: ["ADMIN", "OWNER", "PARTNER"],
      content: <IntegrationsTab />,
    },
    {
      name: "Modules",
      rolesAllowed: ["OWNER", "PARTNER", "ADMIN"],
      content: <Modules />,
    },
    {
      name: "Billing",
      isBillingRelated: true,
      rolesAllowed: ["OWNER", "PARTNER", "ADMIN"],
      content: <CurrentBilling />,
    },
    {
      name: "Subscription",
      isBillingRelated: true,
      rolesAllowed: ["OWNER", "PARTNER", "ADMIN"],
      content: <SubscriptionSettings />,
    },
  ];
  const allowedTabs = allTabs
    .filter((tab) => {
      return tab.rolesAllowed.includes(profileRole);
    })
    .filter((tab) => {
      if (!tab.isBillingRelated) return true;
      return currentProfile.hasBillingAccess;
    });

  const { tabIndex, handleTabsChange } = useTabNavigation(
    allowedTabs,
    "Account"
  );

  if (isLoading) {
    return <LoadingBox />;
  }
  if (isErrorAccountData) {
    return <Text>{errorAccountData.message}</Text>;
  }

  return (
    <PageShell breadcrumbs={breadcrumbs}>
      {isLoading && <LoadingBox />}
      {isErrorAccountData && <Text>{errorAccountData.message}</Text>}
      <Tabs index={tabIndex} onChange={handleTabsChange}>
        <TabList>
          {allowedTabs.map((tab) => (
            <Tab key={tab.name}>{tab.name}</Tab>
          ))}
        </TabList>

        <TabPanels>
          {allowedTabs.map((tab, idx) => (
            <TabPanel key={tab.name}>
              {tabIndex === idx && tab.content}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </PageShell>
  );
};

export default AccountPage;
